export default "__VITE_ASSET__DiwTZ9HE__"